import React from 'react';

const StepTitle = ({ currentStepIndex, totalSteps, title, locales }) => {
  return (
    <div className="step-title">
      <span className="step-title__status">
        {locales.admin.stepOf
          .replace('%{current}', currentStepIndex)
          .replace('%{total}', totalSteps)}
      </span>
      <span className="step-title__text">{` ${title}`}</span>
    </div>
  );
};

export default StepTitle;
